import React, {useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import {ScopeName, OwnershipTransferPrivateBuyerStep, ServiceType} from './Constant/Constant';
import {
  setCurrentStep,
  setShowPopUp,
  resetState,
  validateTransferAccess,
  setTransferProductData,
  setBuyerPersonalData,
  needsToSignCollaborationApproval,
} from './OwnershipTransferBuyerSlice';
import {saveToHistory} from '../OwnershipTransferBlock/OwnershipTransferSlice';
import Popup from '../../Shared/Popup/PopUp';
import OwnershipTransferBuyerPopupWrapper from './Popup/OwnershipTransferBuyerPopupWrapper';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import OwnershipTransferBuyerMain from './OwnershipTransferBuyerMain';
import {hideAppLoader, showAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {lastIndexOf} from 'lodash';

const OwnershipTransferBuyer = (props) => {
  useEffect(() => {
    return () => {
      props.hideAppLoader();
      props.resetState();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.data.currentStep]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.authentication.isAuthenticateFinish && props.authentication.loginData.magicLinkParameters != null) {
          //collaboration
          props.needsToSignCollaborationApproval(props.authentication.loginData.magicLinkParameters.otpPhone);
          const buyerData = {
            firstName: props.authentication.loginData.magicLinkParameters.firstName,
            lastName: props.authentication.loginData.magicLinkParameters.lastName,
          };
          props.setBuyerPersonalData(buyerData);
          if (props.authentication.loginData.magicLinkParameters.scopeName == ScopeName.TransferCli) {
            const productData = {
              number: props.authentication.loginData.magicLinkParameters.phoneNumber,
              name: props.authentication.loginData.magicLinkParameters.productType,
              type: ServiceType.Cellular,
            };
            props.setTransferProductData(productData);
            props.setCurrentStep(OwnershipTransferPrivateBuyerStep.SelectPackage);
            props.hideAppLoader();
          } else {
            const productData = {
              number: props.authentication.loginData.magicLinkParameters.phoneNumber,
              name: props.authentication.loginData.magicLinkParameters.productType,
              type: ServiceType.StationaryLine,
            };
            props.setTransferProductData(productData);
            props.validateTransferAccess({});
          }
        } else {
          props.showAppLoader();
        }
      }
    },
    [props.authentication],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        const timeoutId = setTimeout(() => {
          props.saveToHistory(props.data.currentStep);
        }, 1500);

        return () => clearTimeout(timeoutId); // Cleanup
      }
    },
    [props.data.currentStep],
  );

  useClearStateResetFlag();

  return (
    <div className='ownershipTransferPrivate ownershipTransfer'>
      <OwnershipTransferBuyerMain iContent={props.iContent} />
      <Popup className={`mainPopup ${props.data.currentPopUp}`} showPopUp={props.data.showPopup} onClose={() => props.setShowPopUp(false)}>
        <OwnershipTransferBuyerPopupWrapper />
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateBuyer,
  authentication: state.authentication,
});

const mapDispatchToProps = {
  resetState,
  setCurrentStep,
  saveToHistory,
  setShowPopUp,
  showAppLoader,
  hideAppLoader,
  validateTransferAccess,
  setTransferProductData,
  setBuyerPersonalData,
  needsToSignCollaborationApproval,
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferBuyer);
